import { useEffect, useState } from 'react';
import { HistoryDataRes } from '../types/res';
import axios from 'axios';

export const useHistory = () => {
  const [historyData, setHistoryData] = useState<HistoryDataRes[]>([]);

  const fetchHistory = () => {
    try {
      axios.get(`${process.env.REACT_APP_API_URL}/history`).then((res) => {
        setHistoryData(res.data);
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  return { historyData };
};
